import api from './axios';

export const getFiles = async (params = {}) => {
  return await api.get('/api/v1/files', { params });
};

export const getFile = async (id) => {
  return await api.get(`/api/v1/files/${id}`);
};

export const uploadFiles = async (files, module, visibility = 'private', metadata = {}, onUploadProgress) => {
  const formData = new FormData();
  formData.append('module', module);
  formData.append('visibility', visibility);
  
  if (Object.keys(metadata).length > 0) {
    for (const key in metadata) {
      formData.append(`metadata[${key}]`, metadata[key]);
    }
  }

  if (Array.isArray(files)) {
    files.forEach((file) => {
      formData.append('files[]', file);
    });
  } else {
    formData.append('file', files);
  }

  const response = await api.post('/api/v1/files/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });

  return response;
};

export const deleteFile = async (id) => {
  const response = await api.delete(`/api/v1/files/${id}`);
  return response.data;
};

export const downloadFile = async (id, fileName) => {
  // First, get the file details to check if we need a signed URL
  const response = await getFile(id);
  const fileData = response.data;

  let urlToDownload = fileData.file_url;
  
  // If private, the API returns a temporary_url
  if (fileData.visibility === 'private' && fileData.temporary_url) {
    urlToDownload = fileData.temporary_url;
  }

  if (!urlToDownload) {
    throw new Error('Download URL not available.');
  }

  // Create an anchor and trigger download
  const link = document.createElement('a');
  link.href = urlToDownload;
  link.target = '_blank';
  link.download = fileName || fileData.original_name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
